import YDeleteModal from './DeleteModal';

export { YDeleteModal };
export default YDeleteModal;
